import styled, { css } from 'styled-components';

import { SelectButton } from '@/shared/components/ui/button/select-button/select-button';

export const SelectDateTrigger = styled(SelectButton)<{ $hasValue?: boolean }>`
  && {
    height: 2.5rem;
    padding: 0 0.75rem;
    box-shadow: inset 0 0 0 1px ${({ theme }) => theme.palette.stroke.primary};
    background: ${({ theme, disabled }) =>
      disabled
        ? theme.palette.background.default
        : theme.palette.background.input};
    transition: 0.2s ease-in-out;
    color: ${({ $hasValue, theme }) =>
      $hasValue ? theme.palette.text.primary : theme.palette.text.secondary};

    &:hover {
      background: none;
    }

    ${({ clicked, theme }) =>
      clicked &&
      css`
        box-shadow: inset 0 0 0 1px ${theme.palette.primary.main};
      `}

    svg.select-button-arrow {
      color: ${({ theme, disabled }) =>
        disabled ? theme.palette.text.disabled : theme.palette.primary.main};
    }
  }
`;
